import { Component, NgZone } from '@angular/core';

import { SuburbPageRef } from '../../../../services/suburb-areas.service';
import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { MapToolsService } from '../workspace/map-tools.service';
import { PagePublisherService } from '../workspace/page-publisher.service';
import { PanelNavService } from '../workspace/panel-nav.service';
import { SuburbDetailService } from '../workspace/suburb-detail.service';
import { WorkspaceStateService } from '../workspace/workspace-state.service';
import { GateSummary, gateOf, leadSource, nearbyNote, pct } from './suburb-facts';

/**
 * A suburb's Overview tab (#256, #253, #260): its region (put in the active one, take out), its sub-regions (join one,
 * leave one), its website page (Publish, Un-publish, Edit, Remove), the search gate and what the crawl found.
 */
@Component({
  selector: 'app-suburb-overview',
  templateUrl: './suburb-overview.component.html',
  styleUrls: ['./suburb-overview.component.scss'],
})
export class SuburbOverviewComponent {
  /** The "Add to sub-region…" picker: it goes back to its placeholder once the pick is made. */
  addPick: string | null = null;
  readonly pct = pct;
  readonly nearbyNote = nearbyNote;
  readonly leadSource = leadSource;

  constructor(
    public state: WorkspaceStateService,
    public catalogue: SuburbCatalogueService,
    public detail: SuburbDetailService,
    public publisher: PagePublisherService,
    public mapTools: MapToolsService,
    public nav: PanelNavService,
    private zone: NgZone
  ) {}

  get area(): { regionId: string | null; covered: boolean; subRegions: string[] } {
    return this.state.selectedArea;
  }

  get page(): SuburbPageRef | undefined {
    return this.catalogue.pageOf(this.state.selectedCode);
  }

  get gate(): GateSummary | null {
    return gateOf(this.detail.detail);
  }

  /** The suburb whose panel this is (the tab only shows for one). */
  get code(): string {
    return this.state.selectedCode ?? '';
  }

  addToSubRegion(id: string | null): void {
    if (id && this.state.selectedCode) this.mapTools.membership(this.state.selectedCode, id, 'add');
    // Back to the placeholder once PrimeNG has finished with the pick.
    setTimeout(() =>
      this.zone.run(() => {
        this.addPick = null;
        this.state.redraw();
      })
    );
  }
}
